
export interface RecordedSessionSummary {
  id: string;
  resourceName: string;
  requestedByUserName: string | null;
  requestedByUserEmail: string | null;
  requestedByUserAvatarId: string | null;
  requestedAt: string;
  durationSeconds: number;
  sizeBytes?: number;
  truncated?: boolean;
}

export interface SessionRecordingSummary extends RecordedSessionSummary {
  sizeBytes: number;
  truncated: boolean;
  format: string;
  width: number | null;
  height: number | null;
}

export function formatSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;

  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
